import React, { useEffect, useState } from 'react';
import { Box, Container, IconButton, Menu, MenuItem } from '@mui/material';
import {
    Heading1,
    TextDefault,
    Block,
} from '@awarego-ui/components';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { useStores } from '../../hooks/use-stores';
import { Language as LanguageIcon } from '@material-ui/icons';
import { observer } from 'mobx-react';

const Logo = styled.div`
    img {
        max-height: 50px;
        max-width: 130px;
    }
    padding-bottom: 24px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: ${(props) => {
        if (props.position === 'left') return 'flex-start';
        if (props.position === 'right') return 'flex-end';
        return 'center';
    }};
    ${(props) =>
        props.noMargin &&
        css`
            margin: 0;
        `}
`;

function InfosecError({ error }) {
    const { brandingStore, store, commonStore } = useStores();
    const { logo, account_name } = brandingStore;
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [languages, setLanguages] = useState([]);

    useEffect(() => {
        if (commonStore.languages && commonStore.languages.length > 0) {
            const readableLanguages = commonStore.languages.map((lang) => ({
                id: lang.code,
                name: lang.english_name || lang.name || lang.code,
            }));
            setLanguages(readableLanguages);
        }
    }, [commonStore.languages]);

    const showLanguageMenu =
        languages.length > 1 && !brandingStore.hideLanguageList;

    const handleLanguageClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleLanguageClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageSelect = async (languageCode) => {
        await store.setLanguage(languageCode, true);
        handleLanguageClose();
    };

    return (
        <Container maxWidth="md">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="100vh"
                textAlign="center"
                position="relative"
            >

                <Block
                    resetMargin
                    style={{
                        position: 'relative',
                        padding: '32px 24px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        background: '#fff',
                        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                        maxWidth: 560,
                        width: '100%',
                    }}
                >
                    {showLanguageMenu && (
                        <>
                            <IconButton
                                onClick={handleLanguageClick}
                                style={{
                                    position: 'absolute',
                                    top: '6px',
                                    right: '6px',
                                    padding: '8px',
                                }}
                                size="small"
                            >
                                <LanguageIcon />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleLanguageClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                {languages.map((lang) => (
                                    <MenuItem
                                        key={lang.id}
                                        onClick={() =>
                                            handleLanguageSelect(lang.id)
                                        }
                                        selected={lang.id === store.language}
                                    >
                                        {lang.name}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </>
                    )}

                    <Logo
                        position={
                            brandingStore.branding &&
                            brandingStore.branding[
                                'ui.minihra_landing_logo_position'
                            ]
                        }
                    >
                        {logo && (
                            <img
                                src={logo}
                                alt={t('logoAlt', account_name)}
                            />
                        )}
                    </Logo>

                    <Heading1 mt={8} mb={8}>
                        {t('Failed to load Assessment Insight')}
                    </Heading1>

                    {error && (
                        <TextDefault lighter mb={16}>
                            {t(error)}
                        </TextDefault>
                    )}
                </Block>
            </Box>
        </Container>
    );
}

export default observer(InfosecError);

